var Ut = Object.defineProperty;
var St = (t, e, n) => e in t ? Ut(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var $ = (t, e, n) => (St(t, typeof e != "symbol" ? e + "" : e, n), n);
import { g as T, s as Xe, l as D, e as w, S as g, v as Ze, m as k, b as M, h as et, E as re, D as W, c as It, r as V, i as kt, j as Et, k as _t, n as Fe, o as ze, a as xt, p as tt, d as Dt, q as rt } from "./metricsReporter-lf84Y5sr.js";
const rr = 360, ir = "ul-app", nr = "#e6e6e6", or = "#bd282a", sr = 1030, He = () => {
  try {
    return window.parent.Intercom;
  } catch {
    return null;
  }
}, We = [Object.freeze(Object.defineProperty({ __proto__: null, disable: () => {
  const t = He();
  t && (t.ul_wasVisible = !!document.querySelector("iframe.intercom-launcher-frame"), t.ul_wasVisible && t("update", { hide_default_launcher: !0 }));
}, enable: () => {
  const t = He();
  t && (t.ul_wasVisible && t("update", { hide_default_launcher: !1 }), delete t.ul_wasVisible);
} }, Symbol.toStringTag, { value: "Module" }))];
class At {
  static disable() {
    We.forEach((e) => e.disable());
  }
  static enable() {
    We.forEach((e) => e.enable());
  }
}
const Ne = "ul-view-sdk-script", Rt = ["ios", "android"], q = "visitors", F = "environments";
async function C(t, e) {
  var i, o, a;
  const { shouldDropOnRateLimit: n, ...s } = e;
  s.headers = Object.assign(T(window.UserLeap), s.headers);
  const r = await Xe(t, { ...s, shouldDropOnRateLimit: n });
  if (r.ok) {
    const l = (i = r.headers) == null ? void 0 : i.get("Authorization"), p = l ? l.split(" ") : void 0, d = p && p.length === 2 ? p[1] : void 0, c = (o = r.headers) == null ? void 0 : o.get("x-ul-visitor-id");
    if (window.UserLeap.userId && c === window.UserLeap.visitorId) {
      const m = D.getItemObject("sprig.anon.env.vid.map");
      m && m[window.UserLeap.envId] === c && (delete m[window.UserLeap.envId], D.setItemObject("sprig.anon.env.vid.map", m));
    }
    d && c && (c !== window.UserLeap.visitorId || window.UserLeap.token !== d) && (x("token", d), x("vid", c), w.emit(g.VisitorIDUpdated, { visitorId: c }), window.UserLeap.token = d, window.UserLeap.visitorId = c);
  }
  return (a = r.json) != null && a.logMessage && console.warn(`[Sprig] ${r.json.logMessage}`), r;
}
function x(t, e) {
  const n = D.getItemObject("userleap.ids");
  let s = n[window.UserLeap.envId];
  s ? s[t] = e : s = { [t]: e }, n[window.UserLeap.envId] = s, D.setItemObject("userleap.ids", n);
}
function De() {
  return window.previewMode ? "0" : window.UserLeap.visitorId ?? "";
}
function R(t, e, n) {
  const s = [window.UserLeap._API_URL, "sdk", t];
  return e && e.forEach((r) => {
    s.push(r), r === F ? s.push(window.UserLeap.envId) : r === q && s.push(De());
  }), n && s.push(n), s.join("/");
}
const X = async (t, e) => {
  var Te, je, Me;
  const { context: n, delay: s, forceBrandedLogo: r, endCard: i, isFeedback: o = !1, heatmap: a, locale: l, previewMode: p, productConfig: d, questions: c, responseGroupUid: m, surveyId: u, uuid: y, vid: I, sessionReplay: h, studyType: L } = t, f = T(window.UserLeap), S = ie(f), _ = ge(f);
  if (h)
    if (S)
      w.emit(g.ReplayCapture, { responseGroupUid: m, hasQuestions: !!(c != null && c.length), surveyId: u, uploadId: h.uploadId, replayType: h.replayDurationType ?? "before", seconds: h.replayDurationSeconds, generateVideoUploadUrlPayload: { mediaRecordingUid: Ze(), mediaType: "screen", questionId: 1, responseGroupUid: m, surveyId: u, updatedAt: (/* @__PURE__ */ new Date()).toISOString(), visitorId: window.UserLeap.visitorId, isReplay: !0 } });
    else {
      if (!k.replay)
        return window.UserLeap.reportError("displayQuestions", new Error("Replay module not registered")), { success: !1, message: "Replay module not registered", surveyState: "no survey" };
      k.replay.scheduleOrCaptureReplay({ responseGroupId: m, surveyId: u, visitorId: I, replayParams: h, completeUploadHeaders: f, apiUrl: window.UserLeap._API_URL, triggerTimestamp: Date.now(), isStandalone: c.length === 0 });
    }
  if (a) {
    if (!k.replay)
      return window.UserLeap.reportError("displayQuestions", new Error("Replay module not registered")), { success: !1, message: "Replay module not registered", surveyState: "no survey" };
    const { eventId: U, replayParams: J, responseGroupUid: fe, surveyId: ve } = a;
    await k.replay.initializeReplay({ maxReplayDurationSeconds: 300, maxInflightRequests: window.UserLeap.maxInflightReplayRequests, teardownAfter: !0 }), k.replay.tryReplayAction(() => {
      var qe;
      return (qe = k.replay) == null ? void 0 : qe.scheduleCapture({ apiUrl: window.UserLeap._API_URL, completeUploadHeaders: f, eventId: U, isHeatmap: !0, replayParams: J, responseGroupId: fe, surveyId: ve, triggerTimestamp: Date.now(), visitorId: I });
    }, "Error in scheduling/capturing replay");
  }
  if (I == null || !(c != null && c.length))
    return M.info("CannotDisplaySurvey", { vid: I }), { success: !1, message: "[Sprig] no survey found", surveyState: "no survey" };
  if (window.UserLeap.container) {
    M.info("AlreadyDisplayingSurvey");
    const U = "[Sprig] (ERR-409) Found an existing Survey container, aborting rendering of this survey";
    return console.warn(U), { success: !1, message: U, surveyState: "no survey" };
  }
  if (I !== window.UserLeap.visitorId && y !== window.UserLeap.visitorId && !window.previewMode) {
    const U = "Attempted to display survey to a different visitor";
    return window.UserLeap.reportError("DisplaySurvey", new Error(U)), { success: !1, message: U, surveyState: "no survey" };
  }
  M.info("ShowingSurvey", { surveyId: u }), (Te = k.replay) == null || Te.RecordSurveyShown({ id: u, userAgent: window.navigator.userAgent }), At.disable(), w.emit(g.SurveyWillPresent, { name: g.SurveyWillPresent, "survey.id": u });
  let O, b, E, A, z = document.createElement("div");
  const K = (U) => {
    const { "view.version": J } = U;
    J !== f["x-ul-sdk-version"] && nt(), w.removeListener("verify.view.version", K);
  };
  w.on("verify.view.version", K), window.UserLeap.useMobileStyling = _, et(f) ? (O = "ul-direct-embeded-frame", b = document.head, E = window, A = !1, (() => {
    const U = T(window.UserLeap), J = ie(U), fe = window.UserLeap.forceDirectEmbed, ve = U["userleap-platform"] === "web";
    return J || fe && ve;
  })() && (it(u, o), z.id = O, window.UserLeap.container.appendChild(z), ot(), w.emit(g.SurveyLifeCycle, { state: "presented" }), w.emit(g.SurveyPresented, { name: g.SurveyPresented, "survey.id": u }))) : { frameId: O, contentWinDocHead: b, contentWindow: E, hasOverlay: A, iframe: z } = Ct({ productConfig: d, useMobileStyling: _, surveyId: u, isFeedback: o }), window.UserLeap.frameId = O;
  const B = { apiURL: window.UserLeap._API_URL, cards: c, configureExitOnOverlayClick: (U) => {
    w.once(g.CloseSurveyOnOverlayClick, U);
  }, context: n, endCard: i, envId: window.UserLeap.envId, eventEmitFn: w.emit.bind(w), fontFamily: window.UserLeap.fontFamily, fontFamilyURL: window.UserLeap.fontFamilyURL, forceBrandedLogo: r, frame: z, headers: f, locale: l, mobileSDKVersion: window.UserLeap.mobileSDKVersion, previewKey: D.getItem("sprig.previewKey"), previewMode: p, productConfig: { framePosition: d == null ? void 0 : d.framePosition, desktopDisplay: d == null ? void 0 : d.desktopDisplay, placement: d == null ? void 0 : d.placement }, responseGroupUid: m, startingQuestionIdx: (je = window.UserLeap.config) == null ? void 0 : je.startingQuestionIdx, studyType: L, styleNonce: window.UserLeap.styleNonce, surveyId: u, tabTitle: document.title, trackPageViewUrl: e, ulEvents: re, upchunkLibraryURL: window.UserLeap.upchunkLibraryURL, useMobileStyling: _, userId: y, viewDocument: E == null ? void 0 : E.document, viewWindow: E, visitorAttributes: { externalUserId: window.UserLeap.userId, email: window.UserLeap.email }, ...window.UserLeap._config };
  (Me = window.UserLeap._config) != null && Me.startingQuestionIdx && (window.UserLeap._config = { ...window.UserLeap._config, startingQuestionIdx: null });
  const Lt = (o ? window.UserLeap.feedbackCustomStyles : window.UserLeap.customStyles) ?? d.customStyles;
  B.customStyles = Lt, E && (E.__cfg = B);
  const me = window.UserLeap.viewSDKURL ? window.UserLeap.viewSDKURL : B.path, Oe = document.getElementById(Ne);
  Oe && Oe.remove();
  const ye = function() {
    const U = document.createElement("script");
    return window.UserLeap.nonce && U.setAttribute("nonce", window.UserLeap.nonce), U.id = Ne, U;
  }(), Ce = () => {
    window.UserLeap.container && Object.assign(window.UserLeap.container.style, { display: "flex" });
  };
  if (B.installationMethod === "web-npm" || B.installationMethod === "web-npm-bundled") {
    const { default: U } = await import("./view-CGgXNSb2.js");
    U.configure(B), A && window.UserLeap.container && Ce();
  } else
    me && (ye.src = me, A && ye.addEventListener("load", () => {
      window.UserLeap.container && Ce();
    }), E == null || E.addEventListener("error", (U) => {
      U.target instanceof HTMLScriptElement && U.target.src === me && window.UserLeap.reportError("loadFrameScript", new Error("Frame script failed to load"));
    }, { capture: !0, once: !0 }));
  b == null || b.appendChild(ye);
  const Pe = { success: !0, surveyState: "ready", surveyId: u, responseGroupUid: m };
  return window.UserLeap.isMobileSDK && s && (Pe.delay = s), Pe;
};
function ge(t) {
  var n;
  if (window.UserLeap.useMobileStyling !== void 0)
    return window.UserLeap.useMobileStyling;
  const e = ((n = window.UserLeap.windowDimensions) == null ? void 0 : n.width) ?? document.body.clientWidth;
  return ie(t) || e > 10 && e < 500;
}
function ie(t) {
  return Rt.includes(t["userleap-platform"]);
}
const Ae = "ul-frame";
window.UserLeap && window.Sprig && (window.Sprig._gtm ? window.Sprig = window.UserLeap : window.UserLeap = window.Sprig), window.UserLeap || (window.UserLeap = window.Sprig), window.Sprig || (window.Sprig = window.UserLeap);
const he = "0px", it = (t, e, n) => {
  window.UserLeap.container = document.createElement("div"), window.UserLeap.container.className = "ul-container" + (e ? " ul-container-feedback" : ""), t && (window.UserLeap.container.dataset.studyId = t.toString());
  const s = at();
  n && s && !window.UserLeap.useMobileStyling ? s.appendChild(window.UserLeap.container) : document.body.appendChild(window.UserLeap.container);
}, nt = (t, e) => {
  var s;
  Tt();
  const n = window.UserLeap.container;
  if (n)
    try {
      (s = n.parentNode) == null || s.removeChild(n), window.UserLeap.container = null, x("trackStartUrl", null), w.emit(g.SurveyLifeCycle, { state: "dismissed" }), w.emit(g.SurveyClosed, { name: g.SurveyClosed, initiator: t, "survey.id": parseInt(n.dataset.studyId), ...e && { studyType: e } });
    } catch (r) {
      console.warn(`[Sprig] (ERR-412) Error removing UserLeap container by ${t} ` + n), r instanceof Error && window.UserLeap.reportError("dismissActiveSurvey", r);
    }
}, ot = () => {
  w.once(g.SurveyWillClose, ({ initiator: t, studyType: e }) => {
    w.removeAllListeners(g.CloseSurveyOnOverlayClick), nt(t, e);
  });
}, Ot = (t, e, n, s) => {
  var d, c;
  const r = { position: "fixed", bottom: "0px", right: he, border: 0, backgroundColor: "rgba(0,0,0,0)", zIndex: 2147483646, transition: "height 0.2s ease-in-out", maxWidth: "100%" }, i = Object.assign({}, e, window.UserLeap), { desktopDisplay: o } = e || {}, a = o === "center-modal";
  let l;
  a && (i.framePosition = "center");
  let p = !1;
  if (n)
    (d = window.UserLeap.windowDimensions) != null && d.width ? r.width = `${window.UserLeap.windowDimensions.width}px` : r.width = "100%", (c = window.UserLeap.windowDimensions) != null && c.height ? r.maxHeight = window.UserLeap.windowDimensions.height - 20 + "px" : window.UserLeap.maxHeight ? r.maxHeight = window.UserLeap.maxHeight : r.maxHeight = document.body.clientHeight - 20 + "px", ["light", "dark"].includes(i.overlayStyleMobile) && (p = !0);
  else {
    r.width = "360px", r.maxHeight = window.UserLeap.maxHeight || "66vh";
    const m = () => {
      p = !0, l = { margin: "auto", position: "static" };
    };
    if (s)
      a ? m() : l = { position: "relative", height: "300px" };
    else
      switch (i.framePosition) {
        case "bottomLeft":
          l = { left: he };
          break;
        case "topLeft":
          l = { left: he, top: 0 };
          break;
        case "topRight":
          l = { top: 0 };
          break;
        case "center":
          m();
      }
  }
  return p && ((m, u) => {
    const y = { position: "fixed", overflow: "auto", top: "0px", left: "0px", display: "none", height: "100%", width: "100%", transition: "background-color 0.3s ease-out", zIndex: 2147483646 }, I = u ? m.overlayStyleMobile : m.overlayStyle;
    y["background-color"] = I === "light" ? "rgba(255,255,255, 0.95)" : "rgba(0,0,0,0.9)", u || (y.margin = "auto"), window.UserLeap.container && Object.assign(window.UserLeap.container.style, y);
  })(i, n), Object.assign(t.style, r, l), p;
}, Ct = ({ productConfig: t, useMobileStyling: e, surveyId: n, isFeedback: s }) => {
  var m, u;
  const r = Ae, i = s && t.desktopDisplay === "slider";
  it(n, s, i), Pt();
  const o = document.createElement("iframe");
  o.id = r, o.setAttribute("title", "Sprig User Feedback Dialog");
  const a = Ot(o, t, e, s);
  ot();
  let l = !1;
  o.setHeight = (y) => {
    parseInt(o.style.height) == y && l || (l = !0, o.style.height = `${y}px`, w.emit(g.SurveyHeight, { name: g.SurveyHeight, contentFrameHeight: y, "survey.id": n }));
  };
  let p = !1;
  o.setWidth = (y) => {
    parseInt(o.style.width) == y && p || (p = !0, o.style.width = `${y}px`, w.emit(g.SurveyWidth, { name: g.SurveyWidth, contentFrameWidth: y, "survey.id": n }));
  }, (m = window.UserLeap.container) == null || m.appendChild(o), t && (e ? t.exitOnOverlayClickMobile : t.exitOnOverlayClick) && window.UserLeap.container && (window.UserLeap.container.onclick = () => {
    w.emit(g.CloseSurveyOnOverlayClick);
  }), w.emit(g.SurveyLifeCycle, { state: "presented" }), w.emit(g.SurveyPresented, { name: g.SurveyPresented, "survey.id": n });
  const d = (u = o.contentWindow) == null ? void 0 : u.document;
  if (d && (d.open("text/html", "replace"), d.write("<!doctype html><head></head><body></body></html>"), d.close(), !e)) {
    const y = d.body;
    y.style.display = "flex", y.style.alignItems = "center";
  }
  const c = d == null ? void 0 : d.head;
  return { frameId: r, contentWinDocHead: c, contentWindow: o.contentWindow, hasOverlay: a, iframe: o };
}, st = { [g.SurveyFadingOut]: () => {
  window.UserLeap.container && Object.assign(window.UserLeap.container.style, { "background-color": "rgba(0,0,0,0)" });
} }, Pt = () => {
  Object.entries(st).forEach(([t, e]) => {
    w.on(t, e);
  });
}, Tt = () => {
  Object.entries(st).forEach(([t, e]) => {
    w.off(t, e);
  });
}, j = (t) => !!t && t.nodeType === Node.ELEMENT_NODE, Ve = (t) => t instanceof HTMLElement || t instanceof SVGElement, se = ({ document: t, elementId: e, styleString: n, nonce: s }) => {
  const r = t.getElementById(e);
  if (r)
    return void (r.textContent = n);
  const i = t.createElement("style");
  s && (i.nonce = s), i.textContent = n, i.id = e, t.head.appendChild(i);
}, jt = (t, e) => {
  const n = e.querySelector(".sprig-question-body");
  if (!j(n))
    return t;
  const s = n.scrollHeight;
  return s < 100 ? t : t - (s - 100);
}, Be = (t, e) => {
  const n = e.querySelector(t);
  if (!j(n))
    return 0;
  const s = getComputedStyle(n);
  return parseFloat(s.paddingLeft) + parseFloat(s.paddingRight) + (parseFloat(s.marginLeft) + parseFloat(s.marginRight)) + (parseFloat(s.borderLeftWidth) + parseFloat(s.borderRightWidth));
}, Mt = (t, e, n) => {
  const s = t.querySelector(".ul-card__container"), r = t.querySelector(".ul-app");
  let i = 600, o = 360, a = 0;
  if (j(s) && j(r)) {
    const l = s.querySelector(".ul-card--matrix_grid"), p = !l && e && n;
    try {
      p && (r.style.width = "360px"), i = s.clientHeight, i += ((m) => {
        const u = m.querySelector(".sprig-question-body"), y = m.querySelector(".ul-card"), I = m.querySelector(".ul-card-main-content"), h = m.querySelector(".ul-footer"), L = m.querySelector(".sprig-container");
        let f = 0;
        return j(y) && (f += y.scrollHeight - y.clientHeight), j(I) && (f += I.scrollHeight - I.clientHeight), j(u) && (f += u.scrollHeight - u.clientHeight), j(h) && j(L) && L.clientHeight === 0 && (f += h.clientHeight), f;
      })(t);
      const d = getComputedStyle(s);
      a = i;
      const c = parseFloat(d.marginTop) + parseFloat(d.marginBottom);
      i += c + (parseFloat(d.borderTopWidth) + parseFloat(d.borderBottomWidth)), l && (o = l.scrollWidth, o += Be(".ul-card__container", t), o += Be(".sprig-question-body", t));
    } finally {
      p && r.style.removeProperty("width");
    }
  }
  return [i + 1, o, jt(a, t)];
}, ar = (t) => {
  const e = t.querySelector(".ul-card__container");
  e && (e.scrollTop = 0);
}, at = () => v, G = () => document.getElementById("sprig-feedback-container"), Se = () => document.getElementById("sprig-feedback-loading-animation"), dt = () => !!document.getElementById(Ae);
let $e = !1, v = null, P = null, Re = !1, Z = null, H = null;
const qt = ["bottom-left", "bottom-right", "center-left", "center-right"], ae = () => {
  var e;
  const t = window.UserLeap.container;
  return ((e = t == null ? void 0 : t.parentElement) == null ? void 0 : e.id) === "sprig-feedback-loading-container";
}, lt = () => document.getElementById("sprig-feedback-error-container"), ct = () => {
  if (!v)
    return 0;
  const t = v == null ? void 0 : v.clientWidth, e = window.getComputedStyle(v);
  return t + parseInt(e.borderRightWidth || "0") + parseInt(e.borderLeftWidth || "0");
}, de = (t) => {
  const e = G();
  e && (H != null && H.endsWith("right") ? e.style.right = `${t}px` : H != null && H.endsWith("left") && (e.style.left = `${t}px`));
}, be = () => {
  if (v && (ae() || lt())) {
    w.off(g.SurveyAppeared, Y), Ie();
    const t = ct();
    return de(-t), !0;
  }
  return !1;
}, Y = () => {
  if (!v || !P)
    return;
  const t = Se();
  t && t.remove(), v.style.height = "auto", v.style.width = "auto", P.disabled = !1, Re = !1;
}, Ie = () => {
  if (v && !Se()) {
    const t = (() => {
      if (Se())
        return;
      const e = document.createElement("div");
      return e.className = "ul-loading-spinner-container", e.id = "sprig-feedback-loading-animation", e.role = "progressbar", e.setAttribute("aria-live", "polite"), e.setAttribute("aria-busy", "true"), e.setAttribute("aria-label", "Processing..."), e.innerHTML = `
    <div class="ul-loading-spinner">
      <div class="first"></div>
      <div class="second"></div>
      <div class="third"></div>
      <div class="fourth"></div>
    </div>
  `, e;
    })();
    t && (v.style.height = "300px", v.style.width = "360px", v.appendChild(t));
  }
}, Ge = () => {
  v && P && (de(0), P.disabled = !0, Re = !0);
}, pt = async (t, e, n) => {
  const { buttonTheme: s, customStyles: r, eventId: i, placement: o, desktopDisplay: a, feedbackLabel: l, surveyUuid: p, surveyId: d } = t;
  window.UserLeap.feedbackCustomStyles = void 0;
  let c = G();
  if (c) {
    if (!e && i === Z)
      return;
    c.remove(), w.off(re.SURVEY_FADING_OUT, be);
  }
  Z = i, se({ document, elementId: "sprig-feedback-style", styleString: '.ul-loading-spinner-container{font-size:1.8rem;flex-grow:1;width:100%;height:100%;display:flex;align-items:center;justify-content:center}.ul-loading-spinner{display:inline-block;position:relative;width:6rem;height:6rem}.ul-loading-spinner div{box-sizing:border-box;display:block;position:absolute;width:80%;height:80%;margin:5px;border:5px solid #152e3e;border-radius:50%;animation:lds-ring 1.2s cubic-bezier(.5,0,.5,1) infinite;border-color:#152e3e transparent transparent transparent}.ul-loading-spinner .first{animation-delay:-.45s}.ul-loading-spinner .second{animation-delay:-.3s}.ul-loading-spinner .third{animation-delay:-.15s}@keyframes lds-ring{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.fade-in-transition{animation:fadeIn .4s ease-in}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}#sprig-feedback-button{border-left:0;border-radius:0 8px 8px 0;display:grid;padding:8px;text-align:center;transition:all ease-in-out 1s;z-index:inherit}#sprig-feedback-button:hover{cursor:pointer}.sprig-feedback-button-label{writing-mode:vertical-lr;text-orientation:sideways}.sprig-feedback-button-right{transform:rotate(180deg)}.sprig-feedback-button-bottom{align-self:flex-end;margin-bottom:20px}.sprig-feedback-button-light{background:#efefee;color:#000;border:1px solid #e2e3e1}.sprig-feedback-button-dark{background:#000;color:#fff;border:1px solid #000000}#sprig-feedback-container{display:flex;align-items:center;position:fixed;transition:right .2s linear,left .2s linear;z-index:2147483646}.sprig-feedback-container-left{flex-flow:row-reverse}.sprig-feedback-container-center{top:50%;transform:translateY(-50%)}.sprig-feedback-container-bottom{bottom:0%;margin-bottom:15px}.sprig-feedback-loading-container{align-items:center;background-color:#fff;border:2px solid var(--feedback-border);display:flex;max-height:90vh;max-width:90vw;min-width:0px}.sprig-feedback-loading-container-left{border-left:none;border-radius:0 8px 8px 0}.sprig-feedback-loading-container-right{border-right:none;border-radius:8px 0 0 8px}#sprig-feedback-error-container{margin:auto;text-align:center;width:360px}.sprig-feedback-error-text{font-weight:400;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol}#sprig-feedback-loading-container .ul-container{position:relative;max-height:inherit}#sprig-feedback-loading-animation{position:absolute}.sprig-feedback-loading-container-previews iframe{max-height:inherit!important}', nonce: window.UserLeap.styleNonce }), se({ document, elementId: "ul-custom-style", styleString: r ?? "", nonce: window.UserLeap.styleNonce }), $e = a === "center-modal", H = o;
  const [m, u] = o.split("-");
  ((L) => {
    if (G() || !qt.includes(L))
      return;
    const [f, S] = L.split("-"), _ = document.createElement("div");
    _.id = "sprig-feedback-container", _.classList.add(`sprig-feedback-container-${S}`, `sprig-feedback-container-${f}`), document.body.appendChild(_);
  })(o), c = G(), P = document.createElement("button");
  const y = document.createElement("div");
  y.className = "sprig-feedback-button-label", y.innerText = l, P.appendChild(y), P.id = "sprig-feedback-button", P.classList.add(`sprig-feedback-button-${u}`, `sprig-feedback-button-${m}`, `sprig-feedback-button-${s}`, "fade-in-transition"), w.on(re.SURVEY_FADING_OUT, be), P.addEventListener("click", async () => {
    const L = document.getElementById("sprig-feedback-error-container");
    if (dt() || lt()) {
      if (be()) {
        w.emit(g.SurveyWillClose, { name: g.SurveyWillClose, initiator: W.FeedbackClosed, studyType: "feedbackButton", "survey.id": d });
        const S = G();
        L && S && (S.remove(), Z = null, v = null);
      }
      return;
    }
    if (ge(T(window.UserLeap)) || Re || Ge(), e)
      return v && v.classList.add("sprig-feedback-loading-container-previews"), await X(e), void Y();
    const f = await (async (S) => {
      const _ = await C(R("1", [q], "startFeedbackStudy"), { body: JSON.stringify({ surveyUuid: S }), method: "POST" });
      return _.ok ? _.json : null;
    })(p);
    if (f)
      w.once(g.SurveyAppeared, Y), X({ ...f, studyType: "feedbackButton" }, n);
    else if (v) {
      const S = Ft();
      v.appendChild(S), Y(), v.style.height = "300px", v.style.width = "360px";
    }
  }), c == null || c.appendChild(P), w.emit(g.FeedbackButtonLoaded, { name: g.FeedbackButtonLoaded, "survey.id": d });
  const { useMobileStyling: I, _config: { border: h } } = window.UserLeap;
  if ($e || I)
    de(0);
  else {
    const L = document.createElement("div");
    L.id = "sprig-feedback-loading-container", L.className = `sprig-feedback-loading-container sprig-feedback-loading-container-${u}`, L.style.setProperty("--feedback-border", h), v = L, Ie(), c == null || c.appendChild(L);
    const f = ct();
    de(-f);
  }
  window.UserLeap._config.isOnQuestionsTab && e && !ae() && v && (Ge(), Ie(), v && v.classList.add("sprig-feedback-loading-container-previews"), X(e), Y());
}, Ft = () => {
  const t = document.createElement("div");
  t.id = "sprig-feedback-error-container", t.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  <circle cx="20" cy="20" r="14.5" stroke="#B0B5B7" stroke-width="3"/>
  <path d="M20 12L20 21.6" stroke="#B0B5B7" stroke-width="3" stroke-linecap="round"/>
  <circle cx="19.9984" cy="27.6" r="1.6" fill="#B0B5B7"/>
  </svg>`;
  const e = document.createElement("h3");
  return e.className = "sprig-feedback-error-text", e.innerText = "There was an error while loading the survey", t.appendChild(e), t;
}, ke = new class {
  constructor() {
    $(this, "_ldData", {});
  }
  getAllLaunchDarklyVariations() {
    return this._ldData;
  }
  setLDFlagsVariations(t) {
    try {
      return !(!t || typeof t != "object" || Array.isArray(t)) && (Object.keys(this._ldData).forEach((e) => {
        delete this._ldData[e];
      }), Object.keys(t).forEach((e) => this._ldData[`!launch_darkly_${e}`] = (t[e] ?? 0) + 1), !0);
    } catch (e) {
      return e instanceof Error && window.UserLeap.reportError("setAllLDFlagsVariations", e), console.warn("[Sprig] An issue had occured when setting LaunchDarkly flags and variations."), !1;
    }
  }
}();
Object.freeze(ke);
const oe = new class {
  constructor() {
    $(this, "_optimizelyData", {});
  }
  setOptimizelyExperiment(t, e = !0) {
    if (!t || typeof t != "object")
      return !1;
    const { experiments: n } = t;
    try {
      return e && Object.keys(this._optimizelyData).map((s) => {
        delete this._optimizelyData[s];
      }), n && n.map((s) => {
        const { id: r, variation: i } = s, o = this.transformExperimentId(r);
        i && typeof i == "string" && (this._optimizelyData[o] = i);
      }), !0;
    } catch (s) {
      return s instanceof Error && window.UserLeap.reportError("setOptimizelyExperiment", s), !1;
    }
  }
  getAllOptimizelyExperiments() {
    return this._optimizelyData;
  }
  getOptimizelyVariationName(t) {
    return this._optimizelyData[this.transformExperimentId(t)];
  }
  transformExperimentId(t) {
    return "!optimizely_experiments_" + t;
  }
  getAndSetWebOptimizelyExperiments() {
    var t;
    try {
      if (window && window.optimizely && typeof window.optimizely.get == "function") {
        const e = (t = window.optimizely.get("state")) == null ? void 0 : t.getExperimentStates({ isActive: !0 });
        if (e) {
          const n = Object.keys(e).map((s) => {
            var r, i;
            return (r = e[s].variation) != null && r.name ? { id: s, variation: (i = e[s].variation) == null ? void 0 : i.name } : { id: s, variation: "Original" };
          });
          return this.setOptimizelyExperiment({ experiments: n }, !1), !0;
        }
        return !1;
      }
      return !1;
    } catch (e) {
      return e instanceof Error && window.UserLeap.reportError("getAndSetWebOptimizely", e), !1;
    }
  }
}();
Object.freeze(oe);
class zt {
  constructor(e, n) {
    $(this, "paused");
    $(this, "queue");
    $(this, "ul");
    this.ul = e, this.paused = !1, this.queue = [], this.flush(n);
  }
  flush(e) {
    const n = e.length;
    if (n)
      for (let s = 0; s < n; s++)
        this.push(e[s]);
  }
  isPaused() {
    return this.paused;
  }
  pause() {
    this.paused = !0;
  }
  unpause() {
    this.paused = !1;
    const e = this.queue.slice();
    this.empty(), this.flush(e);
  }
  push(e) {
    if (this.paused)
      this.queue.push(e);
    else if (e instanceof Function)
      e();
    else {
      const n = Array.prototype.slice.call(e, 1), s = e[0], r = this.ul[s];
      r instanceof Function ? r.apply(this.ul, n) : s && console.warn("[Sprig] (ERR-100) No valid UserLeap action called", s);
    }
  }
  perform(e) {
    if (this.paused) {
      let n = () => {
      };
      const s = new Promise(function(r) {
        n = function() {
          r(e());
        };
      });
      return this.queue.push(n), s;
    }
    return e();
  }
  empty() {
    this.queue.length = 0;
  }
}
let ut, wt;
const Ee = (t) => {
  let e = 0, n = t.firstElementChild;
  for (; n; )
    e += Ee(n), n.shadowRoot && (e += Ee(n.shadowRoot)), n = n.nextElementSibling, e++;
  return e;
}, Ke = () => {
  ut.report(Ee(document.body)), wt.report(document.documentElement.innerHTML.length);
}, _e = (t, e) => {
  const n = performance.now();
  document.hidden ? setTimeout(() => _e(t, e), t) : setTimeout(() => {
    const s = performance.now() - n;
    e.report(s / 1e3), setTimeout(() => _e(t, e), t);
  }, 0);
};
let le, ce, pe, ue, Je, N = {};
const ne = (t, e = 1) => {
  const { name: n } = t;
  N[n] = (N[n] || 0) + e;
}, gt = (t) => {
  let e = 1;
  return t.childNodes.forEach((n) => {
    e += gt(n);
  }), e;
}, Qe = (t) => {
  let e = 0;
  return t.forEach((n) => {
    e += gt(n);
  }), e;
}, Ht = (t) => {
  switch (t.type) {
    case "childList":
      return ne(le, Qe(t.addedNodes)), void ne(ce, Qe(t.removedNodes));
    case "attributes":
      return void ne(pe);
    case "characterData":
      return void ne(ue);
  }
}, Wt = (t) => t.forEach(Ht), Nt = () => {
  le.report(N[le.name] || 0), ce.report(N[ce.name] || 0), pe.report(N[pe.name] || 0), ue.report(N[ue.name] || 0), N = {};
}, Vt = (t = 1e3) => {
  le = V("sdk_mutations_nodes_added"), ce = V("sdk_mutations_nodes_removed"), pe = V("sdk_mutations_attributes_changed"), ue = V("sdk_mutations_character_data"), Je = new MutationObserver(Wt), Je.observe(document, { attributes: !0, attributeOldValue: !0, characterData: !0, characterDataOldValue: !0, childList: !0, subtree: !0 }), setInterval(Nt, t);
}, Bt = ({ isWeb: t, reportingIntervalSeconds: e, thresholds: n, postMetrics: s }) => {
  kt(n, (r, i) => {
    var o, a;
    if ((o = k.replay) != null && o.isReplayRecording()) {
      const l = `Value: ${r} on ${i.metric} violated threshold of ${i.type} ${i.value}`;
      (a = k.replay) == null || a.disableRecording("Threshold violated", new Error(l), { reportError: !1 }), window.UserLeap.reportError("Sdk Performance Metric threshold violated", new Error("Sdk Performance Metric threshold violated"), { metricName: i.metric, type: i.type, value: i.value }, { metricName: i.metric }), _t();
    }
  }), Et({ reportingIntervalSeconds: e, postMetrics: s }), t && (((r = 1e3) => {
    const i = V("sdk_event_queue_latency_seconds");
    _e(r, i);
  })(), ((r = 1e4) => {
    ut = V("sdk_dom_nodes_count"), wt = V("sdk_page_html_characters"), Ke(), setInterval(Ke, r);
  })(), Vt());
}, $t = "test", Gt = ["popState", "pushState", "replaceState"];
let ee;
const we = {}, Q = "!email", mt = "pageUrl";
let Le = window.location.href;
function te(t) {
  var a;
  const { pageUrlEvents: e, interactiveEvents: n, dismissOnPageChange: s, platform: r } = window.UserLeap._config;
  if (r && r !== "web")
    return;
  Le !== window.location.href && M.navigation("LocationChange", { from: Le, to: window.location.href }), Le = window.location.href;
  const i = vt().trackStartUrl, o = i ? String(i) : null;
  e && bt(window.location.href), n && (ft(), Kt()), at() && (() => {
    if (ae())
      return;
    const l = G();
    l && (It(Z) || (l.remove(), Z = null, v = null));
  })(), xt.getItem("sprig.isCapturingHeatmap") && ((a = k.replay) == null || a.checkPendingHeatmapsUrl()), !ae() && s && o && o !== window.location.href && t && Gt.includes(t.type) && window.UserLeap("dismissActiveSurvey", W.PageChange);
}
const yt = { capture: !0 }, Kt = () => {
  const t = window.UserLeap._config.interactiveEvents.filter((n) => tt(n, window.location.href)).map((n) => {
    const { name: s, properties: r } = n, { selector: i, innerText: o } = r;
    return i ? (a) => {
      if (Ve(a.target))
        try {
          a.target.closest(i) && window.UserLeap("track", s);
        } catch {
        }
      return !1;
    } : (a) => (Ve(a.target) && a.target.innerText === o && window.UserLeap("track", s), !1);
  }), e = (n) => t.forEach((s) => s(n));
  window.UserLeap._config.interactiveEventsHandler = e, window.addEventListener("click", e, yt);
}, ft = () => {
  window.UserLeap._config.interactiveEventsHandler && window.removeEventListener("click", window.UserLeap._config.interactiveEventsHandler, yt), delete window.UserLeap._config.interactiveEventsHandler;
};
function vt() {
  const t = D.getItemObject("userleap.ids");
  return t && t[window.UserLeap.envId] || {};
}
function ht() {
  if (window.previewMode)
    return;
  const t = D.getItemObject("sprig.anon.env.vid.map") || {}, e = t[window.UserLeap.envId];
  window.UserLeap.visitorId = e || Ze(), M.info("NewVid", { vid: window.UserLeap.visitorId }), x("vid", window.UserLeap.visitorId), e || (t[window.UserLeap.envId] = window.UserLeap.visitorId, D.setItemObject("sprig.anon.env.vid.map", t)), w.emit(g.VisitorIDUpdated, { visitorId: window.UserLeap.visitorId });
}
function bt(t, e, n, s) {
  var r, i;
  try {
    if (t.endsWith("mock_snippet.html"))
      return;
    M.info("PageView", { url: t });
    const o = window.UserLeap._config.pageUrlEvents;
    let a = !1;
    if (o && o.length)
      for (let d = 0; d < o.length && (a = tt(o[d], t), !a); d++)
        ;
    if (!a)
      return;
    window.UserLeap.debugMode && console.info("[DEBUG] Sprig trackPageView", t);
    const l = { url: t };
    s && (l.trackPageView = !0), window.UserLeap._queue.push(["track", mt, e, l, n]);
    const p = (r = document == null ? void 0 : document.querySelector('meta[name="description"]')) == null ? void 0 : r.getAttribute("content");
    (i = k.replay) == null || i.RecordPageView({ ...p && { description: p }, url: t, referrer: document.referrer, pageTitle: document.title });
  } catch (o) {
    o instanceof Error && (o.stack = t, window.UserLeap.reportError("trackPageView", o)), console.warn("[Sprig] (ERR-428) Failed to track page view", o);
  }
}
function Jt() {
  const t = "Backbone" in window && window.Backbone && window.Backbone.history ? window.Backbone.history : window.history;
  "pushState" in t && (t.pushState = /* @__PURE__ */ ((e) => function(...n) {
    const s = e.apply(this, n), r = new Event("pushState");
    return window.dispatchEvent(r), te(r), s;
  })(t.pushState)), "replaceState" in t && (t.replaceState = /* @__PURE__ */ ((e) => function(...n) {
    const s = e.apply(this, n), r = new Event("replaceState");
    return window.dispatchEvent(r), te(r), s;
  })(t.replaceState)), ["hashchange", "popstate"].forEach((e) => window.addEventListener(e, te, !0));
}
async function Ue(t, e) {
  const n = De();
  t && !e && (window.UserLeap._config.mode = $t);
  const s = ge(T(window.UserLeap)), r = await C(function(i) {
    const o = new URL(R("1", [F], "questions"));
    return Object.entries(i || {}).forEach(([a, l]) => {
      l && o.searchParams.append(a, String(l));
    }), o.toString();
  }({ desktopDisplay: window.UserLeap._config.desktopDisplay, isMobile: s, previewLanguage: window.UserLeap._config.previewLanguage, surveyid: t == null ? void 0 : t.surveyId, surveytemplateid: t == null ? void 0 : t.surveyTemplateId, vid: n }), { shouldDropOnRateLimit: !0 });
  if (!r.ok)
    return r.reportError && r.error && (console.warn("[Sprig] (ERR-414) Failed to request questions from the server", r.error), window.UserLeap.reportError("getQuestions", r.error)), { success: !1, surveyState: "no survey" };
  if (r.json.delay && await rt(r.json.delay), !r.json.isFeedback)
    return X(r.json, ee);
  {
    const { feedbackLabel: i, productConfig: o, surveyUuid: a, feedbackCustomStyles: l } = r.json, { buttonTheme: p, placement: d, desktopDisplay: c } = o;
    pt({ customStyles: l, buttonTheme: p, desktopDisplay: c, eventId: 0, feedbackLabel: i, placement: d, surveyUuid: a, surveyId: t == null ? void 0 : t.surveyId }, r.json);
  }
}
function Qt(t) {
  if (!t)
    return;
  window.UserLeap._config = t, t.mute && window.UserLeap._queue.pause();
  const { interactiveEvents: e, pageUrlEvents: n, dismissOnPageChange: s } = t;
  e && function(r) {
    let i = r.length;
    for (; i; ) {
      const o = Math.floor(Math.random() * i);
      i -= 1;
      const a = r[i];
      r[i] = r[o], r[o] = a;
    }
  }(e), (e || n || s) && (Jt(), te());
}
const Yt = function(t) {
  if (!window.UserLeap)
    return;
  const e = async (r = {}) => {
    var L, f, S, _, O;
    const { userId: i, anonymousId: o, metadata: a = {}, properties: l, showSurveyCallback: p } = r;
    let { eventName: d } = r;
    if (window.UserLeap.debugMode && d !== mt && console.info("[DEBUG] Sprig track", r), t.mode === "test")
      return;
    const c = D.getItem("sprig.previewKey") ?? void 0;
    if (t.requireUserIdForTracking && !window.UserLeap.userId && !i) {
      const b = "[Sprig] - Skipping tracking without userId";
      return console.warn(b), { success: !1, message: b, surveyState: "no survey" };
    }
    if (!d || d.trim().length === 0) {
      d = d ? String(d) : "";
      const b = "[Sprig] - Invalid event name " + d;
      return console.warn(b), { success: !1, message: b, surveyState: "no survey" };
    }
    const m = ee ?? window.location.href;
    a.url || (a.url = m), x("trackStartUrl", m), (f = (L = window.UserLeap) == null ? void 0 : L._config) != null && f.optimizelyEnabled && (ie(T(window.UserLeap)) || oe.getAndSetWebOptimizelyExperiments(), a.optimizelyExperiments = Object.assign({}, oe.getAllOptimizelyExperiments())), (_ = (S = window.UserLeap) == null ? void 0 : S._config) != null && _.launchDarklyEnabled && (a.launchDarklyFlags = ke.getAllLaunchDarklyVariations()), i && (window.UserLeap.userId = i), o && (window.UserLeap.partnerAnonymousId = o), l && (a.eventProperties = l), (O = k.replay) == null || O.RecordEvent({ name: d, url: a.url }), M.info("TrackEvent", { eventName: d });
    const u = window.UserLeap.delayingSurvey || dt() ? await C(R("1", [q], "events/batch"), { body: JSON.stringify({ events: [{ event: d, metadata: a }], previewKey: c }), method: "POST", shouldDropOnRateLimit: !0 }) : await C(R("1", [q], "events"), { body: JSON.stringify({ event: d, metadata: a, previewKey: c }), method: "POST", shouldDropOnRateLimit: !0 });
    if (!u.ok) {
      const b = "[Sprig] (ERR-421) Failed to track event";
      return u.reportError && (console.warn(b, u.error), u.error && window.UserLeap.reportError("track", u.error)), { success: !1, message: b, error: u.error, surveyState: "no survey" };
    }
    i && x("uid", i), o && x("aid", o);
    const y = u.json;
    y.invalidPreviewKey && D.removeItem("sprig.previewKey");
    const I = a.trackPageView ? a.url : void 0;
    return y != null && y.feedbackButton && pt(y.feedbackButton, void 0, I), await async function(b, E) {
      var z, K;
      let A = !0;
      return !(E && ((z = b == null ? void 0 : b.json) != null && z.surveyId) && (window.UserLeap.delayingSurvey = !0, A = await E(b.json.surveyId), window.UserLeap.delayingSurvey = !1, !A)) && ((K = b == null ? void 0 : b.json) != null && K.delay && !window.UserLeap.isMobileSDK && (window.UserLeap.delayingSurvey = !0, await rt(b.json.delay), window.UserLeap.delayingSurvey = !1), A);
    }(u, p) ? function(b) {
      if (!window.UserLeap._config.dismissOnPageChange)
        return !0;
      const E = new URL(b), A = new URL(ee ?? window.location.href);
      return E.hostname === A.hostname && E.pathname === A.pathname;
    }(m) ? X(y, I) : { success: !1, message: "Study should not be displayed after page navigation", surveyState: "no survey" } : { success: !1, message: "[Sprig] Callback returned false, aborting rendering of survey", surveyState: "no survey" };
  }, n = (r, i) => {
    var a;
    const o = (a = r == null ? void 0 : r.querySelector(`[id="${Ae}"]`)) == null ? void 0 : a.contentDocument;
    o && se({ document: o, elementId: "ul-custom-style", styleString: i });
  }, s = { displaySurvey: async (r) => (console.warn("[Sprig] displaySurvey should only be used to debug your studies; not intended for production usage."), window.UserLeap("dismissActiveSurvey", W.Override), Ue({ surveyId: r }, !0)), _previewSurvey(r) {
    window.UserLeap("dismissActiveSurvey", W.Override), Ue({ surveyTemplateId: r }, !1);
  }, _reviewSurvey(r) {
    window.UserLeap("dismissActiveSurvey", W.Override), Ue({ surveyId: r }, !1);
  }, previewSurvey(r) {
    s._previewSurvey(r);
  }, reviewSurvey(r) {
    s._reviewSurvey(r);
  }, mute() {
    window.UserLeap._queue.pause();
  }, unmute() {
    window.UserLeap._queue.unpause();
  }, setVisitorToken() {
    console.warn("[Sprig] setVisitorToken is deprecated.");
  }, dismissActiveSurvey(r = W.API) {
    window.UserLeap.container && w.emit(g.SurveyWillClose, { name: g.SurveyWillClose, initiator: r, "survey.id": parseInt(window.UserLeap.container.dataset.studyId) });
  }, async setAttribute(r, i) {
    if (!r || !i && i !== 0 && i !== !1) {
      const o = "[Sprig] - Disregarding empty attribute / value provided";
      return console.warn(o), { success: !1, message: o };
    }
    return this.setAttributes({ [r]: i });
  }, async setAttributes(r) {
    if (r == null || Object.keys(r).length === 0) {
      const i = "[Sprig] - Disregarding empty attributes provided";
      return console.warn(i), { success: !1, message: i };
    }
    return this.identifyAndSetAttributes({ attributes: r });
  }, async identifyAndSetAttributes(r) {
    if (window.UserLeap.debugMode && console.info("[DEBUG] Sprig identifyAndSetAttributes", r), t.mode === "test")
      return;
    if (r === null || typeof r != "object" || !(r.userId || r.anonymousId || r.attributes)) {
      const d = "[Sprig] - Disregarding empty payload provided";
      return console.warn(d), { success: !1, message: d };
    }
    const { userId: i, anonymousId: o, attributes: a } = r;
    if (t.requireUserIdForTracking && !window.UserLeap.userId && !i) {
      const d = "[Sprig] - Skipping tracking without userId";
      return console.warn(d), { success: !1, message: d };
    }
    if (a) {
      a.email && !a[Q] && (a[Q] = a.email, delete a.email);
      const d = Object.keys(a);
      for (const c of d)
        a[c] === we[c] && delete a[c];
    }
    if (!(a && Object.keys(a).length !== 0 || i && window.UserLeap.userId !== i || o && window.UserLeap.partnerAnonymousId !== o))
      return { success: !0 };
    const l = {};
    let p;
    return i && (l.userId = window.UserLeap.userId = i), o && (l.partnerAnonymousId = window.UserLeap.partnerAnonymousId = o), a && Object.keys(a).length > 0 ? (p = await C(R("1", [F, q], "attributes"), { body: JSON.stringify(a), method: "PUT" }), p.ok ? Object.assign(we, a) : p.reportError && (console.warn("[Sprig] (ERR-432) identifyAndSetAttributes failed", p.error), p.error && window.UserLeap.reportError("identifyAndSetAttributes", p.error))) : p = await C(R("1", [F, q]), { body: JSON.stringify(l), method: "PUT" }), a && a[Q] && (window.UserLeap.email = a[Q]), p.ok && (i && x("uid", i), o && x("aid", o)), { success: !!p.ok };
  }, async removeAttributes(r) {
    if (window.UserLeap.debugMode && console.info("[DEBUG] Sprig removeAttributes", r), t.mode === "test")
      return;
    if (r == null || r.length === 0) {
      const o = "[Sprig] - Disregarding empty attributes provided";
      return console.warn(o), { success: !1, message: o };
    }
    if (t.requireUserIdForTracking && !window.UserLeap.userId) {
      const o = "[Sprig] - Skipping tracking without userId";
      return console.warn(o), { success: !1, message: o };
    }
    const i = await C(R("1", [F, q], "attributes"), { body: JSON.stringify({ delete: r }), method: "DELETE" });
    return !i.ok && i.reportError && (console.warn("[Sprig] (ERR-433) Remove attributes failed", i.error), i.error && window.UserLeap.reportError("removeAttributes", i.error)), { success: !!i.ok };
  }, async addSurveyListener(r) {
    w.on(g.SurveyLifeCycle, r);
  }, async removeSurveyListener(r) {
    w.removeListener(g.SurveyLifeCycle, r);
  }, async addListener(r, i) {
    w.on(r, i);
  }, async removeListener(r, i) {
    w.removeListener(r, i);
  }, async removeAllListeners() {
    w.removeAllListeners();
  }, setPreviewKey(r) {
    r && typeof r == "string" && D.isStorageAvailable && r && D.setItem("sprig.previewKey", r);
  }, async setUserId(r) {
    var a;
    if (window.UserLeap.debugMode && console.info("[DEBUG] Sprig setUserId", r), r == null) {
      const l = `[Sprig] - Invalid userId ${r}`;
      return console.warn(l), { success: !1, message: l };
    }
    if (t.mode === "test" || r === window.UserLeap.userId)
      return;
    window.UserLeap.userId = r;
    const i = window.UserLeap.visitorId, o = await C(R("1", [F, q]), { body: JSON.stringify({ userId: r }), method: "PUT" });
    o.ok ? (i !== window.UserLeap.visitorId && ((a = k.replay) == null || a.clearUserReplayData()), x("uid", r)) : o.reportError && (console.warn("[Sprig] (ERR-420) Failed to set user id", o.error), o.error && window.UserLeap.reportError("setUserId", o.error));
  }, async setPartnerAnonymousId(r) {
    if (window.UserLeap.debugMode && console.info("[DEBUG] Sprig setPartnerAnonymousId", r), r == null) {
      const i = `[Sprig] - Invalid partnerAnonymousId ${r}`;
      return console.warn(i), { success: !1, message: i };
    }
    return window.UserLeap.partnerAnonymousId = r, x("aid", r), { success: !0 };
  }, track: async (r, i, o = {}, a = void 0) => e({ eventName: r, properties: i, metadata: o, showSurveyCallback: a }), identifyAndTrack: async (r) => await e(r), trackPageView(r, i = void 0, o = void 0, a = !0) {
    ee = r, bt(r, i, o, a);
  }, applyFeedbackStyles({ button: r = "", view: i = "" }) {
    window.UserLeap.feedbackCustomStyles = i, document.getElementById("sprig-feedback-style") && se({ document, elementId: "ul-custom-style", styleString: r, nonce: window.UserLeap.styleNonce }), n(document.querySelector(".ul-container-feedback"), i);
  }, applyStyles(r) {
    window.UserLeap.customStyles = r, n(window.UserLeap.container, r);
  }, setWindowDimensions(r, i) {
    var m, u;
    const o = typeof r == "string" ? parseInt(r, 10) : r, a = typeof i == "string" ? parseInt(i, 10) : i;
    isNaN(o) || isNaN(a) || (window.UserLeap.windowDimensions = { width: o, height: a });
    const l = T(window.UserLeap), p = ge(l), d = l["userleap-platform"] === "web";
    if (!window.UserLeap.frameId)
      return;
    const c = document.getElementById(window.UserLeap.frameId);
    c && (window.UserLeap.useMobileStyling && ((m = window.UserLeap.windowDimensions) != null && m.width && (c.style.width = `${window.UserLeap.windowDimensions.width}px`), (u = window.UserLeap.windowDimensions) != null && u.height && (c.style.maxHeight = window.UserLeap.windowDimensions.height - 20 + "px"), c.contentDocument && (c.style.height = String(Mt(c.contentDocument, d && !p, et(l))[0]) + "px")), w.emit(g.SurveyDimensions, { name: g.SurveyDimensions, contentFrameWidth: c.clientWidth, contentFrameHeight: c.clientHeight, "survey.id": parseInt(window.UserLeap.container.dataset.studyId) }));
  }, logoutUser() {
    var r;
    window.UserLeap.debugMode && console.info("[DEBUG] Sprig logout"), M.info("LogOut", { vid: window.UserLeap.visitorId, userId: window.UserLeap.userId }), window.UserLeap.visitorId = null, window.UserLeap.userId = null, window.UserLeap.partnerAnonymousId = null, window.UserLeap.token = null, window.UserLeap.email = null, D.removeItem("userleap.ids"), window.UserLeap._queue.isPaused() && window.UserLeap._queue.empty(), ht(), (r = k.replay) == null || r.clearUserReplayData(), window.UserLeap._queue.unpause();
  }, teardown() {
    ["hashchange", "popstate"].forEach((r) => window.removeEventListener(r, te, !0)), window.UserLeap._config.interactiveEvents && ft(), window.UserLeap("dismissActiveSurvey", W.API), delete window.UserLeap, delete window.Sprig, delete window._Sprig;
  }, integrateOptimizely(r, i = !0) {
    var o, a;
    if ((a = (o = window.UserLeap) == null ? void 0 : o._config) != null && a.optimizelyEnabled)
      try {
        const l = typeof r == "string" ? JSON.parse(r) : r;
        oe.setOptimizelyExperiment(l, i);
      } catch (l) {
        console.warn("[Sprig] Error with integrating Optimizely data"), l instanceof Error && window.UserLeap.reportError("integrateOptimizely", l);
      }
    else
      console.warn("[SPRIG] Optimizely integration is currently not enabled for your product.");
  }, integrateOptimizelyClient(r) {
    var i, o;
    if (!((o = (i = window.UserLeap) == null ? void 0 : i._config) != null && o.optimizelyEnabled))
      return void console.warn("[SPRIG] Optimizely integration is currently not enabled for your product.");
    r.notificationCenter.addNotificationListener("ACTIVATE:experiment, user_id,attributes, variation, event", ({ experiment: a, variation: l }) => {
      const p = { experiments: [{ id: a.id, variation: l.key }] };
      window.UserLeap("integrateOptimizely", p, !1);
    });
  }, importLaunchDarklyData(r) {
    var i, o;
    (o = (i = window.UserLeap) == null ? void 0 : i._config) != null && o.launchDarklyEnabled ? ke.setLDFlagsVariations(r) : console.warn("[SPRIG] LaunchDarkly integration is currently not enabled for your product.");
  }, setVisitorAttribute: (r, i) => (console.warn("[Sprig] setVisitorAttribute is deprecated. Please use setAttribute"), s.setAttribute(r, i)), setEmail: async (r) => s.setAttribute(Q, r), setVisitorEmail: async (r) => (console.warn("[Sprig] setVisitorEmail is deprecated. Please use setEmail"), s.setEmail(r)), _generateVideoUploadUrl: async (r) => async function(i) {
    var a;
    if (!i)
      return;
    const o = `${window.UserLeap._API_URL}/2/environments/integrations/upload`;
    try {
      const l = await fetch(o, { method: "POST", cache: "no-cache", headers: { "Content-Type": "application/json" }, body: JSON.stringify(i) });
      if (l.ok) {
        const p = await l.json();
        return (a = p == null ? void 0 : p.upload) == null ? void 0 : a.url;
      }
      return null;
    } catch (l) {
      console.warn("[Sprig] Error with generating video upload url"), l instanceof Error && window.UserLeap.reportError("generateVideoUploadUrl", l);
    }
  }(r), _reportMetric(r, i) {
    Dt(r, i);
  }, _completeSessionReplay: async ({ surveyId: r, responseGroupUuid: i, eventDigest: o }) => {
    var a;
    return k.replay ? (a = k.replay) == null ? void 0 : a._completeSessionReplay({ surveyId: r, responseGroupUuid: i, eventDigest: o, headers: T(window.UserLeap) }) : (window.UserLeap.reportError("_completeSessionReplay", new Error("Replay module not registered")), !1);
  } };
  Object.assign(window.UserLeap, s);
};
async function Xt(t, e, n = {}, s = {}) {
  const r = window.__cfg && window.__cfg.mode, i = De(), o = window.UserLeap.envId, a = window.document.documentElement, l = { mode: r, screenWidth: window.screen.width, screenHeight: window.screen.height, clientWidth: a.clientWidth, clientHeight: a.clientHeight, location: ee ?? window.location.href, language: window.navigator.language, ...n }, p = { action: t, breadcrumbs: M.breadcrumbs, err: { message: `${e == null ? void 0 : e.name} - ${e == null ? void 0 : e.message}`, stack: e == null ? void 0 : e.stack }, meta: l, vid: i, envId: o, ...s };
  (await C(R("1", null, "errors"), { method: "POST", headers: { "x-ul-error": window.btoa(`userleap-${Date.now()}-error`) }, body: JSON.stringify(p), shouldDropOnRateLimit: !0 })).ok || console.warn("[Sprig] (ERR-444) Failed to report error to API", e);
}
function Zt(t = {}) {
  var s;
  (s = window.SprigLoggerCallback) == null || s.call(window, "Initializing Sprig");
  const e = new URLSearchParams(window.location.search).get("sprigPreviewKey") ?? "";
  async function n() {
    var c, m, u, y, I;
    if (window.UserLeap.loaded)
      return;
    if ((c = window.SprigLoggerCallback) == null || c.call(window, "Loading Sprig"), window.UserLeap.reportError = Xt, window.UserLeap.loaded = !0, window.UserLeap._config = Object.assign({}, t, window.UserLeap.config), window.UserLeap.delayingSurvey = !1, window.UserLeap._config && typeof window.UserLeap._config == "object")
      for (const h in window.UserLeap._config)
        window.UserLeap[h] = window.UserLeap._config[h];
    if (!window.UserLeap.envId) {
      if (!window.UserLeap.appId)
        throw new Error("Missing Environment id");
      window.UserLeap.envId = window.UserLeap.appId;
    }
    window.UserLeap.debugMode && console.info("[DEBUG] Sprig debug mode enabled");
    const r = vt(), i = window.UserLeap.sampleRate;
    let o = r.sampled;
    if (i) {
      if (o === null && (o = Math.random() < i, x("sampled", o)), !o)
        return;
    } else
      o !== null && x("sampled", null);
    window.UserLeap._API_URL || (window.UserLeap._API_URL = "https://api.sprig.com");
    const a = [...window.UserLeap._queue];
    window.UserLeap._queue = new zt(window.UserLeap, []), window.UserLeap._queue.pause();
    for (let h = 0; h < a.length; h++)
      window.UserLeap._queue.push(a[h]);
    const l = r.token;
    l ? (window.UserLeap.token = l, window.UserLeap.visitorId = r.vid ?? null, window.UserLeap.userId = r.uid ?? null, window.UserLeap.partnerAnonymousId = r.aid ?? null) : ht();
    const p = ie(T(window.UserLeap));
    (m = window.SprigLoggerCallback) == null || m.call(window, "Sprig fetching config");
    const d = await async function(h) {
      var _, O;
      const L = T(window.UserLeap);
      document.addEventListener("securitypolicyviolation", Fe);
      const f = await Xe(R("1", [F], "config"), { headers: L });
      if (document.removeEventListener("securitypolicyviolation", Fe), !f.ok)
        return (_ = window.SprigLoggerCallback) == null || _.call(window, "Sprig config fetch failed"), f.reportError && (console.warn("[Sprig] (ERR-422) Failed to load configuration", f.error), f.error && window.UserLeap.reportError("applyRemoteConfig", f.error)), ze("Disabled: failed to fetch configuration"), h;
      const S = f.json;
      return S != null && S.disabled ? ((O = window.SprigLoggerCallback) == null || O.call(window, "Sprig config fetch disabled"), ze(`Disabled: ${S.disabled}`), { disabled: S.disabled }) : Object.assign({}, S, h);
    }(t);
    (u = window.SprigLoggerCallback) == null || u.call(window, "Sprig fetched config"), Bt({ isWeb: !p, reportingIntervalSeconds: d.metricsReportingEnabled || d.mobileMetricsReportingEnabled ? d.metricsReportingIntervalSeconds : 0, thresholds: d.metricThresholds, postMetrics: async (h) => {
      var L;
      await C(R("1", [F], "metrics"), { body: h, method: "POST", headers: { "x-ul-replay-enabled": `${!!((L = k.replay) != null && L.isReplayRecording())}` }, shouldDropOnRateLimit: !0 });
    } }), await ((y = k.replay) == null ? void 0 : y.initializeReplay({ maxReplayDurationSeconds: d.maxReplayDurationSeconds, maxInflightRequests: window.UserLeap.maxInflightReplayRequests ?? 2, replaySettings: d.replaySettings })), Yt(d), await Qt(d), window.UserLeap._queue.unpause(), (I = window.SprigLoggerCallback) == null || I.call(window, "SdkReady"), w.emit(g.SDKReady, { mobileMetricsReportingEnabled: !!d.mobileMetricsReportingEnabled, metricsReportingInterval: d.metricsReportingIntervalSeconds || 0, metricsThresholds: d.metricThresholds || [], maxMobileReplayDurationSeconds: d.maxMobileReplayDurationSeconds, mobileReplaySettings: d.mobileReplaySettings }), w.emit(g.VisitorIDUpdated, { visitorId: window.UserLeap.visitorId }), w.on(g.VisitorIDUpdated, () => {
      for (const h in we)
        delete we[h];
    });
  }
  window.UserLeap.UPDATES = re, window.UserLeap("setPreviewKey", e), document.readyState === "complete" ? n() : window.attachEvent ? window.attachEvent("onload", n) : window.addEventListener("load", () => {
    n();
  }, !1);
}
class xe {
  constructor() {
    this.UPDATES = re;
  }
  displaySurvey(e) {
    window.Sprig("displaySurvey", e);
  }
  mute() {
    window.Sprig("mute");
  }
  unmute() {
    window.Sprig("unmute");
  }
  dismissActiveSurvey() {
    window.Sprig("dismissActiveSurvey");
  }
  setAttribute(e, n) {
    window.Sprig("setAttribute", e, n);
  }
  setAttributes(e) {
    window.Sprig("setAttributes", e);
  }
  identifyAndSetAttributes(e) {
    window.Sprig("identifyAndSetAttributes", e);
  }
  removeAttributes(e) {
    window.Sprig("removeAttributes", e);
  }
  addListener(e, n) {
    window.Sprig("addListener", e, n);
  }
  removeListener(e, n) {
    window.Sprig("removeListener", e, n);
  }
  removeAllListeners() {
    window.Sprig("removeAllListeners");
  }
  setEmail(e) {
    window.Sprig("setAttribute", "!email", e);
  }
  setUserId(e) {
    window.Sprig("setUserId", e);
  }
  setPartnerAnonymousId(e) {
    window.Sprig("setPartnerAnonymousId", e);
  }
  track(e, n = {}, s = {}) {
    window.Sprig("track", e, n, s);
  }
  identifyAndTrack(e) {
    window.Sprig("identifyAndTrack", e);
  }
  trackPageView(e, n, s) {
    window.Sprig("trackPageView", e, n, s);
  }
  applyStyles(e) {
    window.Sprig("applyStyles", e);
  }
  setWindowDimensions(e, n) {
    window.Sprig("setWindowDimensions", e, n);
  }
  logoutUser() {
    window.Sprig("logoutUser");
  }
  teardown() {
    window.Sprig("teardown");
  }
}
const Ye = { configure: (t) => {
  if (!t.envId && !t.environmentId)
    throw new Error("Initialization Error: Sprig configure requires an environmentId");
  if (t.envId || (t.envId = t.environmentId ?? ""), t.installationMethod = "web-npm", window.Sprig)
    return window.Sprig;
  window.Sprig = function() {
    window.Sprig._queue.push(arguments);
  }, Object.getOwnPropertyNames(xe.prototype).map((n) => {
    n !== "constructor" && (window.Sprig[n] = xe.prototype[n]);
  });
  const e = window.Sprig;
  return e.appId = t.envId, e._queue = [], window.UserLeap = e, Zt(t), window.Sprig;
} }, dr = { sprig: Ye, SprigAPI: xe, configure: Ye.configure };
export {
  ir as A,
  At as C,
  rr as D,
  sr as E,
  xe as S,
  Mt as a,
  or as b,
  dr as c,
  nr as d,
  se as e,
  j as i,
  ar as r,
  Ye as s
};
